module.exports = __webpack_public_path__ + "static/media/IMG_20180129_124221.41dc71ea.webp";